// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 380px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

p {
  margin: 0;
  font-size: 0.9rem;
}

.delete-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 0.85rem;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/well-attachments-dialog/delete-confirmation-dialog/delete-confirmation-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["mat-dialog-content {\n  min-width: 380px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\np {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.delete-progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 0.85rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
